<template>
	<section id="colecoes">
			<container textButton="Voltar" :pathName="`${caminhoVolta}`" :pathIcone="true">
			<load-content v-if="loadContent" />
			<div class="collection" v-if="!loadContent"><i class="fas fa-folder"></i> {{colecao.nome}} </div>
			<div class="wrapper" v-if="!loadContent">
				<div class="row" v-for="objeto in colecao.objetos" :key="objeto.ordem">
					<div class="order">#{{objeto.ordem}}</div>
					<div class="rowCinza">
						<div class="name">{{objeto.titulo}}</div>
						<div class="type">{{objeto.tipoNome}}</div>
						<div class="comment" v-if="objeto.comentario" @click="vizualizarComentario(objeto.comentario)"><i class="fas fa-comments"></i></div>
						<div class="comment" v-else><i class="far fa-comments"></i></div>
					</div>
				</div>

				<SubColecoes v-for="(subColecao, index) in colecao.subColecoes" :key="(index + 1)" :subColecoes="subColecao.subColecoes"   :subColecao="subColecao" ></SubColecoes>

				<div class="commentGeneral" v-if="!loadContent && colecao.comentario">
					<p>COMENTÁRIO</p>
					<div class="linha"></div>
					<div class="body">{{colecao.comentario}}</div>
				</div>
			</div>

				<!-- Modal para alteração de comentário -->
			<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
				<template v-slot:body>
					<p class="texto">{{comentario}}</p>
				</template>

				<template v-slot:footer>
					<button-action type="button" :onClick="closeModal" class="xs default">FECHAR</button-action>
				</template>
			</Modal>
			<!-- Final exclusão de área de conhecimento  -->
		</container>
	</section>
</template>

<script>
import container from '@/components/shared/Container'
import Modal from '@/components/shared/Modal'
import ButtonAction from '@/components/shared/ButtonAction'
import { colecoes } from '@/services/colecoes'
import SubColecoes from './inc/SubColecoes'
import EventBus from '@/components/event-bus'
import LoadContent from '@/components/shared/LoadContent'

export default {
	components: { SubColecoes, container, Modal, ButtonAction, LoadContent },
	data () {
		return {
			loadContent: true,
			colecao: {},
			comentario: '',
			isModalVisible: false,
			caminhoVolta: ''
		}
	},
	async created () {
		const colecao = await colecoes.findByIdInTree(this.$route.params.id)

		if (colecao.status === 200) {
			this.caminhoVolta = this.$route.params.botao
			this.colecao = colecao.data
			EventBus.$on('visualizar-comentario', (payLoad) => {
				this.vizualizarComentario(payLoad.comentario)
			})
			this.loadContent = false
		} else {
			this.loadContent = false
		}
	},
	methods: {
		closeModal () {
			this.isModalVisible = false
		},
		vizualizarComentario (comentario) {
			this.comentario = comentario
			this.isModalVisible = !this.isModalVisible
		}
	}
}
</script>

<style lang="scss" scoped>
.collection {
	color: #59708f;
	font-size: 25px;
	display: flex;
	align-items: center;
	padding-top: 50px;
	i {
		font-size: 40px;
		margin-right: 10px;
	}
}
.wrapper {
	color: #000;
	margin-top: 40px;
	.row {
		display: flex;
		margin-bottom: 15px;
		align-items: center;

		.subColecao {
			background-color: #fff;
			flex-grow: 0;
			margin-right: 10px;
			font: Condensed Bold 18px/24px Roboto;
			color: #59708F;
			text-transform: uppercase;
		}
		.order {
			background-color: #fff;
			flex-grow: 0;
			margin-right: 10px;
			font: Condensed Bold 20px/26px Roboto;
			color: #59708F;
		}
		.rowCinza {
			display:flex;
			padding: 10px;
			background-color: #ebf0f9;
			width: 100%;
			border-radius: 6px;
			.name {
				color: #59708F;
				font: Condensed Roboto;
				text-transform: uppercase;
				flex: 5;
			}
			.type {
				flex: 1;
			}
			.comment {
				flex-grow: 0;
				font-size: 25px;
				position: relative;
				span {
					display: inline;
					position: absolute;
					left: -200px;
				}
			}

		}
	}
	.commentGeneral {
		margin-top: 50px;
		background: #061529 0% 0% no-repeat padding-box;
		border-radius: 8px;
		color: #fff;
		padding: 30px 40px 50px 40px;
		.body {
			margin-top: 10px;
			font: Condensed 15px/26px Roboto;
		}
		.linha {
			border-bottom: 1px solid #59708F;
		}
		p {
			margin-top: 5px;
			margin-bottom: 5px;
			font: Condensed Bold 24px/26px Roboto;
		}
	}
}
.far {
	opacity: 0.2;
	cursor: not-allowed;
}
</style>
